import React, { useState, useEffect } from 'react'
import { PostData, fetchData } from '../Services/httpHandelars'
import { useGlobalContext } from '../context'
import Loader from '../Components/Loader';
import Snackbar from '../Components/Snackbar';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';


export const AnalyzerSetup = () => {
  

    const [form, setForm] = useState({ _id: "", analyzerName: "", macAddress: "",macAddress2: "" })
    const [analyzerSetup, setAnalyzerSetup] = useState([])
    const [snacBar, setSnacBar] = useState({ snacStatus: false, message: "", snackType: "" })

    const { setLoading, loading, setUser } = useGlobalContext();
    const navigate = useNavigate();

    useEffect(
        () => {
            if (snacBar.snacStatus === true) {
                setTimeout(() => setSnacBar(false), 3000);
            }
        },

        [snacBar.snacStatus]
    );


    const HandleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const handleEditButton = (id) => {
        const editAnalyzerSetup = analyzerSetup.find(cSetup => cSetup._id === id)
        setForm({
            ...form, _id: editAnalyzerSetup._id, analyzerName: editAnalyzerSetup.AnalyzerName, macAddress: editAnalyzerSetup.MACAddress,
            macAddress2: editAnalyzerSetup.MACAddress2 || "",
        });
    }


    useEffect(() => {
        fetchData("/api/getAnalyzerSetup").then((success) => {
            success = JSON.parse(success)
            if(!success.status && success.message.includes("jwt")){
                setUser(null)
                navigate('/Login')
            }
            else if (success.status){
                const analyzerSetup = success.data;
                setAnalyzerSetup(analyzerSetup);
            }
        })
    }, [])

    const handleSubmit = () => {
        setLoading(true)

        if (form._id && form.analyzerName && form.macAddress) {
            const update = {
                
                analyzerName: form.analyzerName.trim(),
                macAddress: form.macAddress,
                macAddress2: form.macAddress2,
                apiKey: form.apiKey,
                _id: form._id
            }
            
            PostData("/api/updateAnalyzerSetup", update).then((success) => {
                setLoading(false)
                if (success.status === true) {
                    
                    setSnacBar({
                        ...snacBar,
                        snacStatus: success.status,
                        message: success.message,
                        snackType: "Success"
                    })
                    setForm({})

                } else {
                    setLoading(false)

                    setSnacBar({
                        ...snacBar,
                        snacStatus: success.status,
                        message: "Responce Failed",
                        snackType: "Error"
                    })
                }
                fetchData("/api/getAnalyzerSetup").then((success) => {
                    success = JSON.parse(success)
                    const updateAnalyzerSetup = success.data
                    setAnalyzerSetup(updateAnalyzerSetup)
                })
            }).catch((err) => {
                setLoading(false)

                console.log("asd--->", err)
                setSnacBar({
                    ...snacBar,
                    snacStatus: true,
                    message: "Response Failed",
                    snackType: "Error"
                })
            })
        }
        else
        {
            if (form.analyzerName && form.macAddress) {
                const data = {
                    analyzerName: form.analyzerName.trim(),
                    macAddress: form.macAddress,
                    macAddress2: form.macAddress2,
                    apiKey: uuidv4(),
    
                }
                
    
                PostData("/api/saveAnalyzerSetup", data).then((success) => {
                    setLoading(false)
                    console.log(success, "----104")
                    if (success.status === true) {
                        setForm({})
                        // fetchData("/api/getAnalyzerSetup").then((success) => {
                        //     const analyzerSetup = JSON.parse(success)
                        //     setAnalyzerSetup(analyzerSetup)
                        // })
                        let analyzerSetupData = analyzerSetup;
                        analyzerSetupData.push(success.success)
                        setAnalyzerSetup(analyzerSetupData)
                        setSnacBar({
                            ...snacBar,
                            snacStatus: success.status,
                            message: success.message,
                            snackType: "Success"
                        })
                    } else {
                        setLoading(false)
    
                        setSnacBar({
                            ...snacBar,
                            snacStatus: success.status,
                            message: "Responce Failed",
                            snackType: "Error"
                        })
                    }
                    
                }).catch((err) => {
                    setLoading(false)
    
                    console.log("asd--->", err)
                    setSnacBar({
                        ...snacBar,
                        snacStatus: true,
                        message: "Responce Failed",
                        snackType: "Error"
                    })
                })
            } else {
                setLoading(false)
                setSnacBar({
                    ...snacBar,
                    snacStatus: true,
                    message: "Kindly fill all required fields",
                    snackType: "Error"
                })
            }
        }

       

    }

    return (
        <>
            {!loading ? <>
                <div>
                    <div className='grid justify-center font-medium py-4 text-gray-700'>
                        Analyzer Setup
                    </div>
                    <div className='shadow overflow-hidden sm:rounded-md mt-5'>
                        <div className='px-4 py-10 bg-white sm:p-6'>
                            <div className="grid grid-cols-4 gap-4 py-6 px-12">

                                <div className="col-span-2">
                                    <label htmlFor="analyzerName" className="block text-sm font-medium text-gray-700">
                                        Analyzer Name
                                    </label>
                                    <input
                                        type="text"
                                        name="analyzerName"
                                        id="analyzerName"
                                        value={form.analyzerName}
                                        onChange={HandleChange}
                                        autoComplete="given-name"
                                        className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                    />
                                </div>
                                <div className="col-span-2">
                                    <label htmlFor="macAddress" className="block text-sm font-medium text-gray-700">
                                        MAC Address
                                    </label>
                                    <input
                                        type="text"
                                        name="macAddress"
                                        value={form.macAddress}
                                        onChange={HandleChange}
                                        id="macAddress"
                                        autoComplete="given-name"
                                        className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                    />
                                </div>
                                <div className="col-span-2">
                                    <label htmlFor="macAddress2" className="block text-sm font-medium text-gray-700">
                                        MAC Address 2 (optional)
                                    </label>
                                    <input
                                        type="text"
                                        name="macAddress2"
                                        value={form.macAddress2}
                                        onChange={HandleChange}
                                        id="macAddress2"
                                        autoComplete="given-name"
                                        className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                    />
                                </div>
                                {/* <div className="col-span-2">
                                    <label htmlFor="apiKey" className="block text-sm font-medium text-gray-700">
                                        API key
                                    </label>
                                    <input
                                        type="text"
                                        name="apiKey"
                                        id="apiKey"
                                        value={form.apiKey}
                                        onChange={HandleChange}
                                        autoComplete="given-name"
                                        className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                    />
                                </div> */}

                            </div>
                            <div className='grid justify-center'>
                                <button
                                    onClick={handleSubmit}
                                    type='submit'
                                    className='py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'
                                >
                                    {form._id ? "Update" : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className='flex justify-center'>
                        <table className="w-9/12 text-sm text-center text-gray-500 dark:text-gray-400 mt-20">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="py-3 px-6">
                                        Analyzer Name
                                    </th>
                                    <th scope="col" className="py-3 px-6">
                                        MAC Address
                                    </th>
                                    <th scope="col" className="py-3 px-6">
                                        MAC Address 2
                                    </th>
                                    <th scope="col" className="py-3 px-6">
                                        API key
                                    </th>
                                    <th scope="col" className="py-3 px-6">
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    analyzerSetup?.map(cSetup => (
                                        <tr key={cSetup._id} className="bg-white border-b dark:border-gray-700 text-gray-700 font-medium h-12">
                                            <>
                                                {/* <td className='px-6'>{cSetup.ControlName}</td> */}
                                                <td className='px-6'>{cSetup.AnalyzerName}</td>
                                                <td className='px-6'>{cSetup.MACAddress}</td>
                                                <td className='px-6'>{cSetup.MACAddress2 || "-"}</td>
                                                <td className='px-6'>{cSetup.APIKey}</td>
                                                <td className='px-6'><button onClick={() => handleEditButton(cSetup._id)} className='group relative py-1 px-3 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'>Edit</button></td>
                                            </>
                                        </tr>
                                    )
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {snacBar?.snacStatus &&
                    <Snackbar snackType={snacBar?.snackType} message={snacBar.message} status={snacBar?.snacStatus} setSnacBar={setSnacBar} />
                }
            </>
                : <Loader />
            }
        </>
    )
}
